module.exports = __webpack_public_path__ + "img/socks.b61df7b4.svg";